import { render, staticRenderFns } from "./SpaceProvider.vue?vue&type=template&id=767b3084"
import script from "./SpaceProvider.vue?vue&type=script&lang=js"
export * from "./SpaceProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports